{
  "title": "WebRTC 撥號統計",
  "loading": "載入中",
  "disconnected": "未連線",
  "lastUpdate": "最後更新",
  "refresh": "重新整理",
  "signalRConnections": "SignalR 連線數",
  "webCalls": "Web 通話數",
  "proxyConnections": "Proxy 連線數"
}
